import { IInputValidationControllerReturn, InputValidatorController } from "./InputValidationController";
import { IInputValidatorItem as IInputValidationItem, IInputValidationItemController, IInputValidationItemProps } from "./interfaces/InputValidationInterfaces";
interface IProps {
  validationItems: IInputValidationItem[] | Nude;
  itemProps: IInputValidationItemProps;
  itemController: IInputValidationItemController;
  onMount?: () => void;
}

export default class InputValidationFactory {

  public static getInputValidationController(props: IProps): IInputValidationControllerReturn | null {
    if(props.validationItems == null || props.validationItems == undefined || props.validationItems.length == 0) return null

    return InputValidatorController({
      items: props.validationItems,
      itemProps: props.itemProps,
      itemController: props.itemController,
      onMount: props.onMount
    })
  }
}